exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*::-moz-selection {\n  background: var(--text-highlight-color);\n}\n*::selection {\n  background: var(--text-highlight-color);\n}\n*::-moz-selection {\n  background: var(--text-highlight-color);\n}\n*::selection {\n  background: var(--text-highlight-color);\n}\n.root {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n}\n.root .segment-header {\n  padding-bottom: 5px;\n}\n.root .line-chart {\n  display: block;\n  flex: 1;\n  margin-top: -8px;\n  min-height: 0;\n}\n", ""]);

// exports
